// src/components/TestimonialCarousel.js

import React, { useRef, useState } from "react";
import Slider from "react-slick";
import { useWebData } from "../../Context/webDataContext";

import waveBg from "../../aseets/bgImg.png";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

function TestimonialCarousel() {
  const { getTestimonials } = useWebData();
  const sliderRef = useRef(null);
  const [hoveredButton, setHoveredButton] = useState(null);
  const testimonials = getTestimonials();

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  const goPrev = () => sliderRef.current?.slickPrev();
  const goNext = () => sliderRef.current?.slickNext();

  return (
    <section
      className="w-full py-10 pt-0 bg-center bg-no-repeat bg-cover"
      id="testimonials"
      style={{ background: `url(${waveBg}) center/cover no-repeat` }}
    >
      <div className="px-4 lg:px-20 lg:pr-28 relative rounded-lg  ">
        <div className="text-center md:mb-10 px-4 lg:px-20">
          <h2 className="md:text-4xl text-2xl font-bold primary-text mb-3">
            What Our Users Say
          </h2>
          <p className="text-gray-700 max-w-3xl mx-auto text-xm md:text-base">
            Real stories from our happy customers who trust Maideaze for their
            home services.
          </p>
        </div>
        <Slider ref={sliderRef} {...settings}>
          {testimonials.map((item) => (
            <div key={item.id} className="md:px-2 md:py-6 py-4 ">
              <div className="group lg:min-h-[18vw] rounded-xl md:rounded-3xl border-[0.7px] border-[#B5E4CA] bg-white/25  backdrop-blur-[12px] p-3 md:p-5 transition-transform duration-300 hover:bg-[radial-gradient(104.71%_69.4%_at_73.87%_69.4%,_#1D9D67_0%,_#1E8157_21.75%,_#1F6546_51.09%,_#1F573E_72.69%,_#204533_100%)]">
                <div className="flex items-center gap-3 mb-3 ">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-12 h-12 lg:w-20 lg:h-20 rounded-full object-cover border border-white/50"
                  />
                  <div>
                    <h3 className="text-base md:text-lg font-semibold text-gray-800 group-hover:text-white">
                      {item.name}
                    </h3>
                    <p className="text-sm lg:text-base text-[#08875D] group-hover:text-white">
                      {item.designation}
                    </p>
                  </div>
                </div>
                <p className="text-sm md:text-base text-gray-700 group-hover:text-white">
                  {item.review}
                </p>
              </div>
            </div>
          ))}
        </Slider>

        <div className="absolute right-1/2 lg:-bottom-16 lg:right-20 transform -translate-y-1/2 flex gap-3 px-2">
          <button
            onClick={goPrev}
            onMouseEnter={() => setHoveredButton("prev")}
            onMouseLeave={() => setHoveredButton(null)}
            className={`w-10 h-10 rounded-full flex items-center justify-center ${
              hoveredButton === "prev"
                ? "bg-[radial-gradient(104.71%_69.4%_at_73.87%_69.4%,_#1D9D67_0%,_#1E8157_21.75%,_#1F6546_51.09%,_#1F573E_72.69%,_#204533_100%)] text-white text-2xl"
                : "primary-bg text-white text-xl md:text-2xl"
            }`}
            aria-label="Previous"
          >
            <FaArrowLeft size={16} />
          </button>
        </div>

        <div className="absolute right-1/3 lg:-bottom-16 lg:right-8 transform -translate-y-1/2 flex gap-3 px-2">
          <button
            onClick={goNext}
            onMouseEnter={() => setHoveredButton("next")}
            onMouseLeave={() => setHoveredButton(null)}
            className={`w-10 h-10 rounded-full flex items-center justify-center ${
              hoveredButton === "next"
                ? "bg-[radial-gradient(104.71%_69.4%_at_73.87%_69.4%,_#1D9D67_0%,_#1E8157_21.75%,_#1F6546_51.09%,_#1F573E_72.69%,_#204533_100%)] text-white text-2xl"
                : "primary-bg text-white text-xl md:text-2xl"
            }`}
            aria-label="Next"
          >
            <FaArrowRight size={16} />
          </button>
        </div>
      </div>
    </section>
  );
}

export default TestimonialCarousel;
